export default __webpack_public_path__ + "static/media/pixellab--og--about.d8764a87.jpg";